import { NeoReport, Report, DateSelectionComponent } from "@singularsystems/neo-reporting";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import { ReportCategory } from "../ReportCategory";
import CededClientInvestmentCriteria from "./CededClientInvestmentCriteria";
import { Neo } from "@singularsystems/neo-react";

@NeoReport("CededClientInvestmentReport", { category: ReportCategory.InvestorReports })
export default class CededClientInvestmentReport extends Report<CededClientInvestmentCriteria> {

    constructor(private dataCache = AppService.get(DomainTypes.Services.DataCache)) {
        super(CededClientInvestmentCriteria);
    }

    public renderCriteria() {
        return <div>
            <Neo.FormGroup bind={this.criteria.meta.entityId} select={{itemSource: this.dataCache.entities}} />
        </div>;
    }
}